import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { RichTextEntry } from '@adapters/prismic/types/slices';
import RichTextContainer from '@components/cms/RichTextContainer';

const MarkdownCopy = ({ text, className }: RichTextEntry) => (
  <RichTextContainer classNames={className}>
    <ReactMarkdown remarkPlugins={[gfm] as any}>{text}</ReactMarkdown>
  </RichTextContainer>
);

export default MarkdownCopy;
